//api/suggestions.js
import ajax from "../assets/uilt/ajax";

let suggestions = {
  checkApply: (req) => {
    return ajax.post({
      url: "/back/suggestions/update-status",
      param: req.param,
      success: req.success,
    });
  },

  // Get all
  getList: (req) => {
    return ajax.get({
      url: "/back/suggestions/get-page",
      param: req.param,
      success: req.success,
    });
  },

  //
};

export default suggestions;
